module.exports = __webpack_public_path__ + "static/media/padre_pio.7cb616f8.jpg";